<template>
    <Button @click="newpage()">Add New</Button>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'


export default defineComponent({
    setup(){
        const router = useRouter()
        const newpage = () => {
                router.push({ path: '/StockInCreation' })
            }
            return {
                newpage
            }
    }
})


</script>